import { api } from './http';
import type { SotdInput, SotdNote } from './types';

export const sotd = {
  list: (signal?: AbortSignal) => api.get<{ notes: SotdNote[] }>('/sotd', signal),
  get: (id: number) => api.get<{ note: SotdNote }>(`/sotd/${id}`),
  create: (f: SotdInput) => api.post<{ note: SotdNote }>('/sotd', f),
  update: (id: number, f: SotdInput) => api.put<{ note: SotdNote }>(`/sotd/${id}`, f),
  remove: (id: number) => api.del<{ ok: true }>(`/sotd/${id}`),
};
